import React from 'react';
import HeroSection from './HeroSection';
import Breadcrumb from './Breadcrumb';

function Careers() {
  const jobListings = [
    {
      title: 'BSP Developer',
      location: 'Chennai, IND',
      description: 'Work with our team to build amazing applications. ',
      experience: "0-3 years",
      link: 'https://docs.google.com/forms/d/e/1FAIpQLScP4gfwgnqJTpfXbKxLxmI5iQIUfRcO2GpneVDqCyK-VXxsAg/viewform?usp=sharing',
    },
    {
      title: 'Backend Developer',
      location: 'Chennai, IND',
      description: 'Join our backend team to handle complex systems and APIs...',
      experience: "0-3 years",
      link: 'https://docs.google.com/forms/d/e/1FAIpQLScP4gfwgnqJTpfXbKxLxmI5iQIUfRcO2GpneVDqCyK-VXxsAg/viewform?usp=sharing',
    },
    {
      title: 'Site Engineer',
      location: 'On site',
      experience: "0-3 years",
      description: 'Help us install and maintain our products',
      link: 'https://docs.google.com/forms/d/e/1FAIpQLScP4gfwgnqJTpfXbKxLxmI5iQIUfRcO2GpneVDqCyK-VXxsAg/viewform?usp=sharing',
    },
    {
      title: 'ML Developer',
      location: 'Chennai, IND',
      experience: "0-3 years",
      description: 'Build and deploy AI models to drive innovative solutions.',
      link: 'https://docs.google.com/forms/d/e/1FAIpQLScP4gfwgnqJTpfXbKxLxmI5iQIUfRcO2GpneVDqCyK-VXxsAg/viewform?usp=sharing',
    },
    {
      title: 'Hardware Engineer',
      location: 'Chennai, IND',
      experience: "0-3 years",
      description: 'Design, develop, and test hardware systems to ensure performance, reliability, and scalability.',
      link: 'https://docs.google.com/forms/d/e/1FAIpQLScP4gfwgnqJTpfXbKxLxmI5iQIUfRcO2GpneVDqCyK-VXxsAg/viewform?usp=sharing',
    },
    {
      title: 'Embedded Engineer',
      location: 'Chennai, IND',
      experience: "0-3 years",
      description: 'Develop, test, and optimize embedded systems for high-performance and reliable applications.',
      link: 'https://docs.google.com/forms/d/e/1FAIpQLScP4gfwgnqJTpfXbKxLxmI5iQIUfRcO2GpneVDqCyK-VXxsAg/viewform?usp=sharing',
    },
  ];

  return (
    <div>
      {/* Reusable Hero Section */}
      <HeroSection
        heading="Careers"
        backgroundImage="/img/careers.jpg"
      />

      <Breadcrumb />

      <div className='aboutInfo'>

      {/* Job Listings Section */}
      <div className='container'>
      <section className="job-listings ">
        <h2 className='positions'>Open Positions</h2>
        <div className="job-cards">
          {jobListings.map((job, index) => (
            <div key={index} className="job-card">
              <h3>{job.title}</h3>
              <p><strong>Location:</strong> {job.location}</p>
              <p><strong>Experience:</strong> {job.experience}</p>
              <p>{job.description}</p>
              <a href={job.link} className="btn" target='blank'>Apply Now</a>
            </div>
          ))}
        </div>
      </section>
      </div>
    </div>
    </div>
  );
}

export default Careers;
